import React from 'react';

import { IconProps } from '@expo/vector-icons/build/createIconSet';

import { Container } from './styles';

const Icon: React.FC<IconProps<string>> = props => {
  return <Container {...props} />;
};

export default Icon;
